import { getLabelFromStorage } from '@pb/utils'
import { batch } from 'redux-act'

import { SHOW_NOTIFICATION_TIME, TECHNICAL_ERROR_LABELS } from 'features/checkout/constants'
import {
  removeCreditCardFail,
  removeCreditCardStart,
  removeCreditCardSuccess,
} from 'features/checkout/duck/actions'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { deleteCreditCard } from 'features/checkout/requests'
import { showNotification } from 'features/notifications/duck/actions'
import { ThunkResult } from 'redux/types'

export const operationRemoveCreditCard =
  (id: string): ThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    const initialCards = checkoutSelectors.getSavedCards(getState())
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
    dispatch(removeCreditCardStart(id))
    try {
      await deleteCreditCard(id)
      dispatch(removeCreditCardSuccess())
    } catch (error) {
      dispatch(
        batch([
          showNotification({
            content: getLabelFromStorage(TECHNICAL_ERROR_LABELS.general),
            type: 'error',
            timespan: SHOW_NOTIFICATION_TIME,
          }),
          removeCreditCardFail(initialCards),
        ]),
      )
    }
  }
